export default "__VITE_ASSET__D2LJT37k__"